import React from "react";
import ReactDOM from "react-dom/client";
import PrijemnicaZaStampu from "./prijemnicaZaStampu";
import OtpremnicaZaStampu from "../Nova_otpremnica/otpremnicaZaStampu";

export default function handlePrintReceiverDispacher(podaci, tip) {
  const printWindow = window.open("", "_blank", "width=1000,height=700");

  const printContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${tip === "PRIJEMNICA" ? "Prijemnica - Štampa" : "Otpremnica - Štampa"}</title>
        <style>
          html, body {
            margin: 0;
            padding: 0;
            background: #fff;
            font-family: Arial, sans-serif;
          }

          #print-content {
            margin: 0;
            padding: 0;
          }

          @media print {
            html, body {
              margin: 0 !important;
              padding: 2% !important;
              width: auto;
              height: auto;
            }

            #print-content {
              margin: 0 !important;
              padding: 0 !important;
            }
          }
        </style>
      </head>
      <body>
        <div id="print-content"></div>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(printContent);
  printWindow.document.close();

  const printDocument = printWindow.document;
  const printContainer = printDocument.getElementById("print-content");

  const root = ReactDOM.createRoot(printContainer);

  root.render(
    tip === "PRIJEMNICA" ? (
      <PrijemnicaZaStampu podaci={podaci} />
    ) : (
      <OtpremnicaZaStampu podaci={podaci} />
    )
  );

  setTimeout(() => {
    printWindow.focus();
    printWindow.print();
  }, 500);
}